export default "__VITE_ASSET__DMIcbvdj__"